import {
  CircleAlert,
  CircleCheck,
  CircleDashed,
  Info,
  TriangleAlert,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '../../lib/cn';

export type TipoStatus = 'sucesso' | 'alerta' | 'perigo' | 'info' | 'neutro' | 'desenvolvimento';

const APARENCIA: Record<TipoStatus, { icone: LucideIcon; classes: string }> = {
  sucesso: { icone: CircleCheck, classes: 'bg-sucesso-fundo text-sucesso' },
  alerta: { icone: TriangleAlert, classes: 'bg-alerta-fundo text-alerta' },
  perigo: { icone: CircleAlert, classes: 'bg-perigo-fundo text-perigo' },
  info: { icone: Info, classes: 'bg-info-fundo text-info' },
  neutro: { icone: CircleDashed, classes: 'bg-neutro-fundo text-neutro' },
  desenvolvimento: { icone: Wrench, classes: 'bg-desenvolvimento-fundo text-desenvolvimento' },
};

/**
 * Selo de status: sempre ÍCONE + TEXTO + COR. Nunca só cor, para quem tem
 * daltonismo ou usa leitor de tela (WCAG 1.4.1).
 */
export function SeloStatus({
  tipo,
  children,
  className,
}: {
  tipo: TipoStatus;
  children: string;
  className?: string;
}) {
  const { icone: Icone, classes } = APARENCIA[tipo];
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap',
        classes,
        className,
      )}
    >
      <Icone className="size-3.5 shrink-0" aria-hidden="true" />
      {children}
    </span>
  );
}
